// @flow

import ApiObject from '../ApiObject';

import KioskOrderSettings from './KioskOrderSettings';

export default class KioskSettings extends ApiObject {

  order: KioskOrderSettings = new KioskOrderSettings();

  postJsonAssignation(data) {
    this.order = new KioskOrderSettings();
    this.order.fromJson(data.order);
  }

}
